export class CompanyEffectsConfiguration {  
  effects_origin: string; 
  automatic_effects_inmatic:boolean;  

  constructor(effects_origin:string, automatic_effects_inmatic:boolean) {
      this.effects_origin = effects_origin;
      this.automatic_effects_inmatic = automatic_effects_inmatic;     
  }

  clone(): CompanyEffectsConfiguration {
      return new CompanyEffectsConfiguration(this.effects_origin, this.automatic_effects_inmatic);
  }
}
